import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { FadeUp, SectionLabel } from "./Reveal";
import { ABOUT } from "../data/content";
import { useLang } from "../lib/lang";
import { scrollToId } from "../lib/smooth";

const Portrait = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-6%", "6%"]);
  return (
    <div ref={ref} className="relative mx-auto w-full max-w-[300px] lg:mx-0">
      <div className="relative aspect-[3/4] overflow-hidden rounded-t-[999px] ring-1 ring-white/10">
        <motion.img style={{ y, scale: 1.15 }} src="/work/camila.jpg" alt="Camila Eterovic" className="absolute inset-0 h-full w-full object-cover object-top" />
      </div>
      <div className="absolute -bottom-6 -left-4 rotate-[-6deg] rounded-full bg-[var(--acid)] px-5 py-3 font-display text-sm font-bold uppercase text-[var(--ink)] sm:-left-8">
        Chile · Croatia · NYC
      </div>
    </div>
  );
};

export const About = () => {
  const { tr } = useLang();
  return (
    <section id="about" data-testid="about-section" className="mx-auto max-w-7xl px-4 py-24 sm:px-6 lg:px-8 lg:py-36">
      <SectionLabel index="05">{tr({ es: "Sobre mí", en: "About" })}</SectionLabel>
      <div className="mt-12 grid items-center gap-16 lg:grid-cols-12">
        <div className="lg:col-span-4"><Portrait /></div>
        <div className="lg:col-span-8">
          <FadeUp as="h2" className="font-display text-4xl font-extrabold leading-[0.95] tracking-tight sm:text-6xl">{tr(ABOUT.title)}</FadeUp>
          <FadeUp delay={0.1} className="mt-8 space-y-5 text-base leading-relaxed text-zinc-300 md:text-lg">
            <p>{tr(ABOUT.p1)}</p>
            <p>{tr(ABOUT.p2)}</p>
          </FadeUp>
          <button data-testid="about-goto-resume-btn" onClick={() => scrollToId("resume")} className="mt-10 rounded-full border border-white/20 px-6 py-3 text-sm font-semibold transition-colors hover:bg-[var(--acid)] hover:text-[var(--ink)]">
            {tr({ es: "Ver resume completo", en: "See full resume" })} ↓
          </button>
        </div>
      </div>
    </section>
  );
};
